export default {
    user:{},
    townStreet:'',
    orderAddress: [],
    editingAddress: {}
}


// WEBPACK FOOTER //
// ./src/store/state.js